<template>
  <div class="footer">
    <div class="info_box">
      <div class="company">
        <div class="logo"></div>
        <div class="text">河南零一零二信息技术有限公司是一家专注于高效软件制定化开发（业务系统、小程序、APP、网站开发）的互联网公司，依靠成熟领先的企业管理与软件开发技术，定制开发软件迅速成为了行业内产品最专业，行业覆盖广，交付能力最强，成功案例最多，增长速度最快的软件定制服务商。</div>
      </div>
      <div class="customized">
        <div class="title">定制服务</div>
        <div class="text"
             @click="Jump('/homePage/APPdevelopment')"
             style="margin-top: 0.1563rem;">
          APP定制开发
        </div>
        <div class="text"
             @click="Jump('/homePage/Webconstruction')">
          高端网站建设
        </div>
        <div class="text"
             @click="Jump('/homePage/Wechat')">
          小程序定制开发
        </div>
        <div class="text"
             @click="Jump('/homePage/Wechat')">
          微信公众号开发
        </div>
        <div class="text"
             @click="Jump('/homePage/H5')">
          H5开发
        </div>
      </div>
      <div class="AboutUs">
        <div class="title">关于我们</div>
        <div class="text"
             @click="Jump('/AboutUS')"
             style="margin-top: 0.1563rem;">
          企业概况
        </div>
        <div class="text"
             @click="Jump('/AboutUS')">
          公司风采
        </div>
        <div class="text"
             @click="Jump('/AboutUS')">
          资质荣誉
        </div>
        <div class="text"
             @click="Jump('/AboutUS')">
          合作伙伴
        </div>
        <div class="text"
             @click="Jump('/AboutUS/cooperation')">
          合作流程
        </div>
        <div class="text"
             @click="Jump('/AboutUS/recruit')">
          加入我们
        </div>
      </div>
      <div class="Journalism">
        <div class="title">新闻资讯</div>
        <div class="text"
             @click="Jump('/Journalism')"
             style="margin-top: 0.1563rem;">
          企业动态
        </div>
        <div class="text"
             @click="Jump('/Journalism')">
          行业新闻
        </div>
        <div class="text"
             @click="Jump('/Journalism')">
          员工活动
        </div>
      </div>
      <div class="contact">
        <div class="title">联系我们</div>
        <div class="text"
             style="margin-top: 0.1563rem;">
          招商热线：18037190102
        </div>
        <div class="text">
          公司电话：15737179221
        </div>
        <div class="text">
          公司地址：河南省郑州市高新区<br>
          &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;国家大学科技园东区<br>
          &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;18号楼A座4楼6411室
        </div>
      </div>
    </div>
    <div class="copyright_box">
      <div class="content_box">Copyright © 2022 - 2023 河南零一零二信息技术有限公司 豫ICP备2021026137号 | 豫公网安备41010502005244号</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    Jump (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  .info_box {
    height: 2.3698rem;
    background-image: url("../static/images/img/footerbgimg.png");
    background-size: 100% 100%;
    padding: 0rem 1.875rem;
    color: #fff;
    text-align: center;
    display: flex;
    .company {
      margin-top: 0.3646rem;
      width: 1.1979rem;
      text-align: left;
      .logo {
        width: 1.1979rem;
        height: 0.2396rem;
        background-image: url("../static/images/img/footerLogo.png");
        background-size: 100% 100%;
      }
      .text {
        margin-top: 0.1563rem;
        font-size: 0.0729rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 0.1406rem;
        color: #ffffff;
        letter-spacing: 0.0052rem;
        opacity: 1;
      }
    }
    .customized {
      margin-top: 0.337rem;
      margin-left: 0.4948rem;
      text-align: left;
    }
    .AboutUs {
      margin-top: 0.337rem;
      margin-left: 0.3333rem;
      text-align: left;
    }
    .Journalism {
      margin-top: 0.337rem;
      margin-left: 0.4948rem;
      text-align: left;
    }
    .contact {
      margin-top: 0.337rem;
      margin-left: 0.4948rem;
      text-align: left;
    }
    .text {
      font-size: 0.0938rem;
      line-height: 0.18rem;
      cursor: default;
      transition: 0.3s;
    }
    .text:hover {
      color: #ff6100;
    }
    .title {
      position: relative;
      font-size: 0.1146rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 0.2135rem;
      color: #ffffff;
      letter-spacing: 0.0104rem;
      opacity: 1;
      cursor: default;
      transition: 0.3s;
    }
    .title::before {
      content: "";
      position: absolute;
      bottom: -0.02rem;
      left: 0px;
      width: 0.1563rem;
      height: 0.0208rem;
      background-color: #ffffff;
      opacity: 1;
      border-radius: 0px;
    }
    .title:hover {
      color: #ff6100;
    }
  }
  .copyright_box {
    height: 0.3698rem;
    background-color: #000;
    line-height: 0.3698rem;
    text-align: center;
    font-size: 0.1042rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff60;
  }
}
</style>